import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

const GreenCircle = ({ size = 80, style }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor: '#90B752',
      animation: 'zoom-in-out 3s ease-in-out infinite', // Continuous zoom in and out
      '@keyframes zoom-in-out': {
        '0%': {
          transform: 'scale(1)', // Initial size
        },
        '50%': {
          transform: 'scale(1.2)', // Zoom in
        },
        '100%': {
          transform: 'scale(1)', // Zoom out back to original size
        },
      },
      ...style,
    }}
  />
);

const FoodCategories = () => {
  const images = [
    "https://i.postimg.cc/CKXFC4G6/02ad223823bd2b42878a64bc521e5480.png",
    "https://i.postimg.cc/FK7f26mm/image.png", 
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with animation duration
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(intervalId); // Clean up the interval when component is unmounted
  }, [images.length]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography
          variant="subtitle1"
          sx={{ color: '#90B752', mb: 1 }}
          data-aos="fade-up" // Animation when the header appears
        >
          Over 50 years of excellence
        </Typography>
        <Typography
          variant="h3"
          sx={{
            color: '#90B752',
            fontWeight: 'medium',
            mb: 4,
            fontFamily: '"Montserrat", sans-serif',
          }}
          data-aos="fade-up" // Animation when the header appears
        >
          Cgl Food Categories
        </Typography>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          position: 'relative',
          minHeight: '500px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Decorative Circles */}
        <Box
          sx={{
            position: 'absolute',
            top: '5%',
            left: '5%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={120} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '20%',
            left: '20%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={80} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: '20%',
            left: '10%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={100} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: '35%',
            left: '25%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={60} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '5%',
            right: '5%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={120} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: '20%',
            right: '20%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={80} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: '20%',
            right: '10%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={100} />
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: '35%',
            right: '25%',
            '@media (max-width:600px)': {
              display: 'none', // Hide only on mobile screens
            },
          }}
          data-aos="zoom-in" // Animation when the circle appears
        >
          <GreenCircle size={60} />
        </Box>

        {/* Central Image */}
        <Paper
          elevation={3}
          sx={{
            width: '400px',
            height: '400px',
            backgroundColor: '#f5f8f0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 2,
            borderRadius: 4
          }}
          data-aos="fade-up" // Animation when the image appears
        >
          <Box
            component="img"
            src={images[currentImageIndex]} // Dynamically update the image based on the index
            alt="Food products"
            sx={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default FoodCategories;
